import { IdsInput } from '../../lib/types/utils'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendMissionTrackingContracts(input: IdsInput) {
  return restApiClient.url(API.missionTrackings.sendContracts.url).post(input)
}
